/**
 * Created by DSadler on 25/04/2017.
 */

// Defines the structure of drag and drop events

// 3 types - new items, moving existing in editor or saving as a component -- may add more later to deal with image uploads etc

// In both cases communicate the item definition ID as well as the content ID (which may be null)

export const DRAG_TYPE = {
  NEW_ITEM: "NEW_ITEM",
  MOVING_ITEM: "MOVING_ITEM",
};

export const DATA_TRANSFER_TYPE = {
  DRAG_TYPE: "editor/dragType",
  CONTENT_ID: "editor/contentId",
  CONFIG_ID: "editor/configId",
};

// Two levels to accepting a drop - the onhover and then on drop events. Determine whether to allow
// transfer at top, then


// WEBPACK FOOTER //
// ./src/App/Editor/dragDropDefinitions.js